<template>
  <div class="course-invite">
    <div class="course-invite-content">
      <div class="user-ul" v-if="userList.length > 0" @click="inviteListPane = true">
        <div class="user-li" v-for="item in userList.slice(0, 3)" :key="item._id">
          <img v-if="item._source.headimgurl" :src="item._source.headimgurl" alt="" class="user-li-avatar" />
        </div>
        <div class="user-li user-li-count">{{ userList.length }}</div>
      </div>
      <el-button type="text" class="invite-tool-btn" @click="inviteModalShow = true" v-if="isOwner">
        <i class="iconfont iconxiezuo"></i>
        <span>邀请</span>
      </el-button>
      <el-button type="text" class="invite-tool-btn" @click="historyPane = true">
        <i class="iconfont iconjilu"></i>
        <span>记录</span>
      </el-button>
    </div>

    <el-drawer
      :visible.sync="inviteListPane"
      append-to-body
      direction="rtl"
      :modal="false"
      custom-class="normal-drawer"
    >
      <div slot="title">
        <span>协作成员</span>
        <span :style="{ color: '#3d465a', marginLeft: '4px' }">{{ userList.length }}</span>
      </div>
      <div class="invite-pane-content" v-loading="fetching">
        <el-button
          type="text"
          @click="inviteModalShow = true"
          :style="{ padding: 0, marginBottom: '20px' }"
          v-if="isOwner"
        >
          <i class="el-icon-circle-plus" :style="{ fontSize: '32px' }"></i>
          <span :style="{ position: 'relative', top: '-7px' }">邀请新成员</span>
        </el-button>
        <div class="invite-pane-user-ul">
          <div class="invite-pane-user-li" v-for="item in userList" :key="item._id">
            <div class="invite-pane-user-avatar">
              <img v-if="item._source.headimgurl" :src="item._source.headimgurl" alt="" />
            </div>
            <div class="invite-pane-user-info">
              <div class="user-info-name">
                <span>{{ item._source.name || item._source.nickname }}</span>
                <i
                  class="iconfont iconquanyi owner-icon"
                  v-if="item._source.creatorId === userInfo.id && item._source.togetherId === userInfo.id"
                ></i>
              </div>
              <div class="user-info-tel">{{ item._source.tel }}</div>
            </div>
            <el-dropdown
              v-if="isOwner && item._source.togetherId !== userInfo.id"
              @command="val => commandHandle(item, val)"
            >
              <div class="invite-pane-user-tool">
                <i class="iconfont icongengduo"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="edit" :disabled="item._source.limit === 'edit'"
                  >可查看/编辑</el-dropdown-item
                >
                <el-dropdown-item command="read" :disabled="item._source.limit === 'read'">可查看</el-dropdown-item>
                <el-dropdown-item command="del">移除成员</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <el-button class="invite-quit-btn" v-if="!isOwner" @click="quitHandle">
          <span>退出</span>
        </el-button>
      </div>
    </el-drawer>

    <inviteModal
      v-if="inviteModalShow"
      :show.sync="inviteModalShow"
      :courseId="courseDetail._id"
      @success="getTogether()"
    />

    <handleHistory v-if="historyPane" :show.sync="historyPane" :courseId="courseDetail._id" />
  </div>
</template>

<script>
import inviteModal from './inviteModal';
import handleHistory from './handleHistory';
import { mapGetters } from 'vuex';
import { services } from '@/service';

export default {
  components: { inviteModal, handleHistory },
  data() {
    return {
      fetching: false,
      userList: [],
      inviteModalShow: false,
      inviteListPane: false,
      historyPane: false
    };
  },
  props: {
    courseDetail: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isOwner() {
      return this.courseDetail._source.userId === this.userInfo.id;
    }
  },
  mounted() {
    this.getTogether();
  },
  methods: {
    async getTogether() {
      try {
        this.fetching = true;
        const result = await services.courseware.getCourseTogether(this.courseDetail._id);
        this.userList = result;
      } catch (err) {
        this.$error(err);
      } finally {
        this.fetching = false;
      }
    },
    commandHandle(user, type) {
      if (type === 'del') {
        this.delUserHandle(user);
      }
      if (['edit', 'read'].includes(type)) {
        this.updUserAuthHandle(type, user);
      }
    },
    quitHandle() {
      this.$confirm('是否退出该课题协作', '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: async (action, instance, done) => {
          if (action !== 'confirm') {
            done();
            return;
          }
          try {
            instance.confirmButtonLoading = true;
            const ownerItem = this.userList.find(item => item._source.togetherId === this.userInfo.id);
            await services.courseware.delTogether(this.courseDetail._id, ownerItem._id);
            this.$message.success('退出成功');
            this.$router.push({ name: 'home' });
            done();
          } catch (err) {
            this.$error(err);
          } finally {
            instance.confirmButtonLoading = false;
          }
        }
      });
    },
    delUserHandle(user) {
      this.$confirm('是否移除该成员', '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: async (action, instance, done) => {
          if (action !== 'confirm') {
            done();
            return;
          }
          try {
            instance.confirmButtonLoading = true;
            await services.courseware.delTogether(this.courseDetail._id, user._id);
            const idx = this.userList.findIndex(item => item._id === user._id);
            if (idx !== -1) {
              this.userList.splice(idx, 1);
            }
            this.$message.success('移除成功');
            done();
          } catch (err) {
            this.$error(err);
          } finally {
            instance.confirmButtonLoading = false;
          }
        }
      });
    },
    async updUserAuthHandle(limit, user) {
      const preAuth = user._source.limit;
      try {
        user._source.limit = limit;
        await services.courseware.updTogetherAuth({ id: user._id, limit });
        this.$message.success('修改成功');
      } catch (err) {
        user._source.limit = preAuth;
        this.$error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.course-invite {
  height: 100%;
  .course-invite-content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .invite-tool-btn {
      font-size: 14px;
      margin-left: 14px;

      .iconfont {
        margin-right: 2px;
      }
    }

    .user-ul {
      display: flex;
      align-items: center;
      cursor: pointer;
      .user-li {
        position: relative;
        font-size: 12px;
        color: #2c3443;
        line-height: 20px;
        text-align: center;
        width: 20px;
        height: 20px;
        background-color: #ebeef5;
        border: 1px solid #fff;
        border-radius: 50%;
        margin-left: -6px;
        overflow: hidden;

        .user-li-avatar {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        &.user-li-count {
          margin-left: 4px;
          border-color: #ebeef5;
        }
      }
    }
  }
}
.invite-pane-content {
  .invite-pane-user-ul {
    .invite-pane-user-li {
      display: flex;
      align-items: flex-start;
      margin-bottom: 20px;

      .invite-pane-user-avatar {
        width: 32px;
        height: 32px;
        background-color: #ebeef5;
        border-radius: 50%;
        overflow: hidden;

        & > img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .invite-pane-user-info {
        flex: 1;
        width: 0;
        margin-left: 7px;

        .user-info-name {
          font-size: 14px;
          color: #2c3443;

          .owner-icon {
            color: #ffa938;
            margin-left: 6px;
          }
        }

        .user-info-tel {
          font-size: 12px;
          color: #9599a5;
          margin-top: 4px;
        }
      }

      .invite-pane-user-tool {
        color: #9599a5;
        padding: 5px;
        padding-right: 0;
        cursor: pointer;
      }
    }
  }

  .invite-quit-btn {
    width: 100%;
    margin-top: 100px;
  }
}
</style>
